module.exports = __webpack_public_path__ + "img/imgXharra-5.dd3163a0.png";